import script from "./MonthlyReportBar.vue?vue&type=script&setup=true&lang=js"
export * from "./MonthlyReportBar.vue?vue&type=script&setup=true&lang=js"

import "./MonthlyReportBar.vue?vue&type=style&index=0&id=474a20d4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-474a20d4"]])

export default __exports__